import { createSlice, current, Draft, PayloadAction } from "@reduxjs/toolkit";

interface PageTime {
  [page: string]: number;
}
interface TimeTrackerState {
  prevPageTime: {
    url: string;
    totalTime: number;
  };
  totalTime: number;
  pageTimes: PageTime;
  startTime: number | null;
  currentPage: string | null;
}
const initialState: TimeTrackerState = {
  prevPageTime: {
    url: "",
    totalTime: 0,
  },
  totalTime: 0,
  pageTimes: {},
  startTime: null,
  currentPage: null,
};

const timeTrackerSlice = createSlice({
  name: "timeTracker",
  initialState,
  reducers: {
    startTracking: (state, action: PayloadAction<string>) => {
      state.startTime = Math.ceil(Date.now() / 1000);
      state.currentPage = action.payload;
    },
    stopTracking: (state) => {
      if (state.startTime && state.currentPage) {
        const timeSpent = Math.ceil(Date.now() / 1000 - state.startTime);
        state.prevPageTime = {
          url: state.currentPage,
          totalTime: timeSpent,
        };
        state.totalTime = timeSpent;
        if (state.pageTimes[state.currentPage]) {
          state.pageTimes[state.currentPage] += timeSpent;
        } else {
          state.pageTimes[state.currentPage] = timeSpent;
        }
        state.startTime = null;
        state.currentPage = null;
      }
    },
  },
});

export const { startTracking, stopTracking } = timeTrackerSlice.actions;
export default timeTrackerSlice.reducer;
